module.exports = __webpack_public_path__ + "img/gaku_text_03.743bfd97.png";